import { PartyPopper, Heart, Sparkles, Check } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/556193761185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento.";
const DECORATION_IMG = "https://forestgreen-dugong-952582.hostingersite.com/wp-content/uploads/2026/05/IMG_4310-4-1024x576.jpeg";

const FEATURES = [
  { icon: PartyPopper, text: "Decoração completa do planejamento à montagem" },
  { icon: Heart, text: "Atendimento humano e personalizado" },
  { icon: Sparkles, text: "Festas temáticas e criativas" },
  { icon: Check, text: "Compromisso, prazos e qualidade" },
];

export default function Services() {
  return (
    <section id="servicos" data-testid="services-section" className="py-24 bg-[#E4DCCC]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <img
              src={DECORATION_IMG}
              alt="Decoracao de festa"
              className="w-full h-[400px] lg:h-[500px] object-contain rounded-3xl bg-[#f0ebe4]"
              data-testid="services-image"
            />
            {/* Stats overlay */}
            <div className="absolute -bottom-6 -right-4 lg:-right-8 bg-white rounded-3xl p-6 shadow-xl" data-testid="services-stat">
              <p className="text-4xl font-light text-[#E4077B] tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
                +2.000
              </p>
              <p className="text-xs tracking-[0.15em] uppercase text-[#555555] mt-1">Festas Realizadas</p>
            </div>
          </div>

          {/* Right: Content */}
          <div className="space-y-8">
            <div>
              <span className="text-[#00929A] text-xs tracking-[0.25em] uppercase font-medium">Amine Festas Brasília</span>
              <h2
                className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3 leading-snug"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                Vamos começar a planejar
                <span className="text-[#E4077B]"> sua festa?</span>
              </h2>
            </div>

            <p className="text-[#555555] leading-relaxed text-base">
              Da criação à montagem, você não se preocupa com nada. Chega e encontra tudo pronto. Cada comemoração é única. Aqui, cuidamos de tudo na decoração, do planejamento à montagem final, para que você viva esse momento com leveza, alegria e a certeza de uma celebração inesquecível.
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {FEATURES.map(({ icon: Icon, text }, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 p-4 bg-white rounded-2xl hover-lift"
                  data-testid={`services-feature-${i}`}
                >
                  <div className="w-10 h-10 rounded-xl bg-[#E4077B]/10 flex items-center justify-center flex-shrink-0">
                    <Icon size={18} className="text-[#E4077B]" />
                  </div>
                  <p className="text-sm text-[#555555] leading-relaxed">{text}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="services-cta-btn"
                className="inline-flex items-center justify-center bg-[#E4077B] hover:bg-[#c8066a] text-white px-8 py-3.5 rounded-full text-sm font-medium transition-all duration-300 hover:shadow-lg hover:shadow-[#E4077B]/20"
              >
                Falar com Amine
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="services-quote-btn"
                className="inline-flex items-center justify-center border border-[#00929A] text-[#00929A] hover:bg-[#00929A] hover:text-white px-8 py-3.5 rounded-full text-sm font-medium transition-all duration-300"
              >
                Orçamento Personalizado
              </a>
            </div>
          </div>
        </div>

        {/* Formats section */}
        <div className="mt-24 text-center">
          <span className="text-[#f39200] text-xs tracking-[0.25em] uppercase font-medium">Formatos</span>
          <h2
            className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Decorações com amor e propósito
          </h2>
          <div className="w-12 h-0.5 bg-[#f39200] mx-auto mt-4 mb-8" />
          <p className="text-[#555555] max-w-3xl mx-auto leading-relaxed text-base">
            Chá de Bebê ou Revelação - Festas Infantis Temáticas e Personalizadas - Eventos Empresariais e Corporativos - Designer de Balões para Diversos Momentos! Na Amine Festas, cada celebração é única mas todas têm algo em comum: o cuidado em cada detalhe.
          </p>
        </div>
      </div>
    </section>
  );
}
